import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SliderService {
	@Output() readonly openSliderEvent: EventEmitter<string> =
		new EventEmitter<string>();
	@Output() readonly closeSliderEvent: EventEmitter<string> =
		new EventEmitter<string>();
	@Output() readonly scrollDownSliderEvent: EventEmitter<string> =
		new EventEmitter<string>();

	openSlider(sliderId: string): void {
		this.openSliderEvent.emit(sliderId);
	}

	closeSlider(sliderId: string): void {
		this.closeSliderEvent.emit(sliderId);
	}

	scrollDownSlider(sliderId: string): void {
		this.scrollDownSliderEvent.emit(sliderId);
	}
}
